import React from "react";
import Footer from "../Fotter";

function PrebookingPolicy() {
    return (
        <div>
            <div className="container mx-auto px-4 py-12">
                <h2 className="text-4xl font-semibold text-center text-gray-800 mb-12">Prebooking Terms and Conditions</h2>

                <ul className="list-disc list-inside space-y-2">
                    <li>I hereby agree to the following terms of iPhone Registration.</li>
                    <li>I am voluntarily participating in the iPhone registration program and I understand that this program does not guarantee that I will receive the preferred iPhone or any other phone or product at the time of launch or even within any stipulated timeframe.</li>
                    <li>This registration does not entitle anyone to a confirmed delivery of iPhone or any other product from GWS Shopsy.</li>
                    <li>I can Pre-order a maximum of 1 unit from GWS Shopsy as part of the iPhone registration program.</li>
                    <li>In case I am offered my preferred model of iPhone, I agree to complete the purchase transaction immediately and within a period not exceeding 24 hours from offer time.</li>
                    <li>I agree to use the device purchased from GWS Shopsy for individual use only and will not resell this device to anybody else.</li>
                    <li>GWS Shopsy will not be liable in any way in case they are not able to fulfill my demand of the registered iPhone.</li>
                    <li>In case GWS Shopsy is not able to supply the product as per my preference, then refund of advance amount, if any, will be processed as per the refund policy.</li>
                    <li>In order to cancel this registration, a written cancellation request will need to be submitted by the customer. Any refunds, if applicable, on cancellation will be processed as per the refund policy.</li>
                    <li>The refunds, if applicable, will be made in mode of cheque only and will be processed within 15 days of the cancellation request.</li>
                    <li>In case of advance payments made thru credit or debit card, a cancellation charge of 3% will be applicable.</li>
                    <li>GWS Shopsy reserves the right to not disclose any data pertaining to customer registrations to any customers or third party under this program.</li>
                    <li>GWS Shopsy may share this data with Apple India Pvt. Ltd and its Distributors like Ingram Micro India Ltd in case needed for any validation of registrations or to enable supplies of products.</li>
                    <li>In case of any dispute, GWS Shopsy reserves the right to cancel this registration at any time.</li>
                </ul>

                <div className="mt-8">
                    <h3 className="text-2xl font-medium text-gray-800">Customer Support</h3>
                    <ul className="list-inside pl-5 space-y-2 text-lg text-gray-700 mt-4">
                        {/* <li><strong>Address:</strong> Thakur Ji Ki Haweli Jalpa Mata Mandir Ke Pass Rajgarh, Rajgarh Madhya Pradesh, Bharat Pin 465661</li> */}
                        <li><strong>Address:</strong> Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001</li>
                        <li><strong>Phone:</strong> +91 8047154521</li>
                        <li><strong>Email:</strong> info@gwsshopsy.com</li>
                        <li><strong>Website:</strong> www.gwsshopsy.com</li>
                    </ul>

                    {/* <div className="mt-8">
                        <h3 className="text-2xl font-medium text-gray-800">Customer Support</h3>
                        <ul className="list-inside pl-5 space-y-2 text-lg text-gray-700 mt-4">
                            <li><strong>Address:</strong> Shop No. 4, 105 Jai Bajrang Nagar Keladevi Road, Happy Tower In Front of King George School Dewas, Dewas Madhya Pradesh, 455001</li>
                            <li><strong>Phone:</strong> +91 8047154521</li>
                            <li><strong>Email:</strong> info@gwsshopsy.com</li>
                            <li><strong>Website:</strong> www.gwsshopsy.com</li>
                        </ul>
                    </div> */}
                </div>

            </div>
            <Footer />
        </div>
    );
}

export default PrebookingPolicy;
